<template>
    <div>
        <div class="row">
            <div class="col-12">
                <g-table-sync
                    :app="app"
                    :view="view"
                    :columns="columns"
                    :default-limit="20"
                    pagination="loadmore"
                    @edit="openForm"
                >
                    <template
                        slot="provider"
                        slot-scope="{item}"
                    >
                        <router-link v-if="item.provider" :to="{name: 'providerInfo', params: {id: item.provider._EntityId}}">{{ item.provider.name }}</router-link>
                        <span v-else></span>
                    </template>

                    <template slot="price" slot-scope="{item}">
                        <span v-if="item.price > 0">
                            {{item.price | price}} €
                        </span>
                        <span v-else></span>
                    </template>

                    <template slot="iva" slot-scope="{item}">
                        <span v-if="item.iva > 0">
                            {{item.iva }}%
                        </span>
                        <span v-else></span>
                    </template>
                </g-table-sync>
            </div>
        </div>

        <custom-form
            :id="id"
            ref="form"
            :visible="formEnabled"
            @close="closeForm"
        />
    </div>
</template>

<script>
import customForm from './form';

export default {
    name: 'gOODS',
    components: { customForm },
    data() {
        return {
            app: 'goods',
            view: 'goodList',
            columns: [
                {
                    title: 'Artículo',
                    index: 'name',
                    order: true,
                    search: true,
                },
                {
                    title: 'Proveedor',
                    index: 'provider',
                    search: true,
                    slot: 'provider'
                },
                {
                    title: 'Precio',
                    index: 'price',
                    slot: 'price',
                    order: true,
                    search: true
                },
                {
                    title: 'IVA',
                    index: 'iva',
                    slot: 'iva',
                    order: true,
                    search: true
                },
                {
                    title: 'Acciones',
                    width: '190px',
                    slot: '_actions'
                }
            ],
            formEnabled: false,
            lineErrors: null,
            fileUploading: null,
            id: 0
        };
    },
    created() {
        this.$hub.$on('newGood', () => {
            this.id = 0;
            this.formEnabled = true;
        });
    },
    beforeDestroy() {
        this.$hub.$off('newGood');
    },
    methods: {
        openForm(item) {
            this.id = item._EntityId;
            this.formEnabled = true;
        },
        closeForm() {
            this.id = 0;
            this.formEnabled = false;
        }
    }
};
</script>

<style lang="scss">
</style>
